import MenuOpenIcon from "@mui/icons-material/MenuOpen";
import {
  Box,
  Collapse,
  Divider,
  Drawer,
  IconButton,
  Paper,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import React, { useEffect, useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { ArrowAround, HaityLogo } from "../../assets/svg";
import { useChangeBizzApp } from "../../common/hooks/useChangeBizzApp";
import { useMenuRoute } from "../../common/hooks/useMenuRoute";
import { getUserSession } from "../../helper/user";
import { getApiByProduct } from "../../modules/UAA/service/permissionConfigService";
import { setOpenMenu } from "../../redux/themeReducer";
import { setCurrentPermission } from "../../redux/userReducer";
import { BACK_GROUND } from "../colors";
import { LEFT_MENU_WIDTH } from "../constant";
import { useNavigate } from "react-router";

// @ts-ignore
const LeftMenu = (props) => {
  const dispatch = useDispatch();
  // @ts-ignore
  const { open } = useSelector((state) => state.theme);
  // @ts-ignore
  const { currentBizzApp } = useSelector((state) => state.bizzApps);
  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.up("md"));
  const navigate = useNavigate();

  const { handleOpenDialog, renderDialogChoseBizzApp } = useChangeBizzApp();

  const userId = useMemo(() => getUserSession(""), []);

  const getListPermission = async (listRole) => {
    const listApi = listRole.map((v) => {
      return getApiByProduct({ page: 0, size: 2000, roleId: v.id });
    });
    const resAll = await Promise.all(listApi);
    let listApiPer = [];
    resAll.forEach((item) => {
      listApiPer = listApiPer.concat(item.data?.data?.content);
    });
    dispatch(setCurrentPermission(listApiPer ?? null));
  };

  const { renderMenuRoutes } = useMenuRoute();

  useEffect(() => {
    if (userId?.roles) getListPermission(userId?.roles);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  const onCloseMenu = () => {
    dispatch(setOpenMenu(false));
  };

  const listMenu = () => {
    return (
      <Box
        className="flex flex-col relavtive overflow-auto"
        style={{
          width: LEFT_MENU_WIDTH,
          maxHeight: "100vh",
          height: "100%",
          overflow: "auto",
          boxShadow: "5px 0px 8px rgba(0, 0, 0, 0.08)",
          transform: "scale(1)",
        }}
      >
        <Box
          position="sticky"
          top="0px"
          style={{ backgroundColor: BACK_GROUND }}
          zIndex={1}
        >
          <Box
            style={{
              height: 62,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              zIndex: 1,
              backgroundColor: BACK_GROUND,
            }}
            alignItems="center"
            paddingLeft="20px"
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 8,
                cursor: "pointer",
              }}
              onClick={() => navigate("/")}
            >
              <img alt="mosan_logo" width={100} height={25} src={HaityLogo} />
              {/* <Typography variant="caption">Mosan</Typography> */}
            </Box>
            <IconButton onClick={onCloseMenu}>
              <MenuOpenIcon fontSize="small" />
            </IconButton>
          </Box>
          <Divider className="w-full" />
          <Box
            style={{
              height: 62,
              display: "flex",
              flexDirection: "row",
              justifyContent: "space-between",
              zIndex: 1,
            }}
            alignItems="center"
            paddingLeft="20px"
          >
            <Box
              style={{
                display: "flex",
                flexDirection: "row",
                alignItems: "center",
                gap: 8,
              }}
            >
              <Typography variant="caption">{currentBizzApp?.name}</Typography>
            </Box>
            <IconButton onClick={handleOpenDialog}>
              <img src={ArrowAround} alt="" />
            </IconButton>
          </Box>
        </Box>
        <Divider className="w-full" />
        {renderMenuRoutes()}
      </Box>
    );
  };
  return (
    <div>
      {matches ? (
        <div>
          <Collapse in={open} orientation="horizontal">
            <Paper
              style={{
                height: "100vh",
                boxShadow: "5px 0px 8px rgba(0, 0, 0, 0.08)",
                backgroundColor: "#F6F7FB",
                transform: "scale(1)",
                zIndex: 100,
              }}
            >
              {listMenu()}
            </Paper>
          </Collapse>
        </div>
      ) : (
        <Drawer
          anchor={"left"}
          open={open}
          variant="temporary"
          onClose={onCloseMenu}
          PaperProps={{
            style: { width: LEFT_MENU_WIDTH, backgroundColor: "#F6F7FB" },
          }}
        >
          <Paper
            style={{
              height: "100vh",
              boxShadow: "5px 0px 8px rgba(0, 0, 0, 0.08)",
            }}
          >
            {listMenu()}
          </Paper>
        </Drawer>
      )}
      {renderDialogChoseBizzApp()}
    </div>
  );
};

export default LeftMenu;
